import { createSlice } from "@reduxjs/toolkit";

export const viewSlice = createSlice({
  name: "view",
  initialState: {
    crumbs: [],
  },
  reducers: {
    setBreadcrumbs: (state, action) => {
      state.crumbs = [
        {
          name: "Home",
          slug: "/app",
        },
        ...action.payload,
      ];
    },
    clearBreadcrumbs: (state, action) => {
      state.crumbs = [
        {
          name: "Home",
          slug: "/app",
        },
      ];
    },
  },
});

export const { setBreadcrumbs, clearBreadcrumbs } = viewSlice.actions;

export default viewSlice.reducer;
